var lib_core          = require("lib-core");

var DraggingModel = function () {
    lib_core.Model.call(this);

    this.uiSelectionModel = this.value("uiSelectionModel", false);
};
lib_core.inherit(DraggingModel, lib_core.Model);
lib_core.JsonParser.registerClass(DraggingModel, "DraggingModel");

module.exports = DraggingModel;
